<div class="container course-detail">
    <div class="box-default3 w-100 shadow-lg">
      <h4>Value Added Courses</h4>
        <img src="assets/img/course/vac1.png" alt="VAC Image" class="img-fluid">
    </div>
</div>